var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManipalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1339,
    height: 741,
    viewBox: "0 0 1339 741",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 182C11.8188 182 23.5224 179.672 34.4412 175.149C45.36 170.626 55.2816 163.997 63.639 155.64C71.9964 147.282 78.6258 137.361 83.1492 126.442C87.6726 115.522 90 103.819 90 92C90 80.181 87.6726 68.4778 83.1492 57.5584C78.6258 46.6391 71.9964 36.7177 63.639 28.3605C55.2816 20.0031 45.36 13.3738 34.4412 8.85084C23.5224 4.32792 11.8188 2 0 2V92V182Z",
    fill: "#FF9E42",
    fillOpacity: 0.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109 92C109 80.181 111.327 68.4778 115.851 57.5584C120.374 46.6391 127.004 36.7177 135.361 28.3605C143.718 20.0031 153.64 13.3738 164.559 8.85084C175.478 4.32792 187.181 2 199 2V92H109Z",
    fill: "#FF9E42",
    fillOpacity: 0.49
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163 182C182.882 182 199 166.106 199 146.5C199 126.894 182.882 111 163 111C143.118 111 127 126.894 127 146.5C127 166.106 143.118 182 163 182Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67 249C86.8822 249 103 233.106 103 213.5C103 193.894 86.8822 178 67 178C47.1177 178 31 193.894 31 213.5C31 233.106 47.1177 249 67 249Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.5 193C185.972 193 205 212.028 205 235.5V278H120V235.5C120 212.028 139.028 193 162.5 193Z",
    fill: "#FF9E42",
    fillOpacity: 0.49
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 260C89.9719 260 109 279.028 109 302.5V345H24V302.5C24 279.028 43.0281 260 66.5 260Z",
    fill: "#FF9E42",
    fillOpacity: 0.49
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1339 543C1333.09 543 1327.24 544.164 1321.78 546.425C1316.32 548.687 1311.36 552.002 1307.18 556.18C1303 560.359 1299.69 565.32 1297.43 570.779C1295.16 576.239 1294 582.091 1294 588C1294 593.909 1295.16 599.761 1297.43 605.221C1299.69 610.68 1303 615.641 1307.18 619.82C1311.36 623.998 1316.32 627.313 1321.78 629.575C1327.24 631.836 1333.09 633 1339 633V543Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1249 741H1339V651C1327.18 651 1315.48 653.327 1304.56 657.851C1293.64 662.374 1283.72 669.004 1275.36 677.361C1267 685.718 1260.37 695.64 1255.85 706.559C1251.33 717.478 1249 729.181 1249 741Z",
    fill: "#FF9E42"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M232 490C244.081 490 256.045 492.379 267.207 497.003C278.368 501.627 288.51 508.404 297.053 516.947C305.596 525.49 312.373 535.632 316.997 546.793C321.621 557.955 324 569.919 324 582C324 594.081 321.621 606.045 316.997 617.207C312.373 628.368 305.596 638.51 297.053 647.053C288.51 655.596 278.368 662.373 267.207 666.997C256.045 671.621 244.081 674 232 674V490Z",
    fill: "#F35F28"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M122 582H214V674C201.919 674 189.955 671.621 178.793 666.997C167.632 662.373 157.49 655.596 148.947 647.053C140.404 638.51 133.627 628.368 129.003 617.207C124.379 606.045 122 594.081 122 582Z",
    fill: "#F35F28"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.5 563C156.342 563 140 546.658 140 526.5C140 506.342 156.342 490 176.5 490C196.658 490 213 506.342 213 526.5C213 546.658 196.658 563 176.5 563Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1317 0C1317 14.3139 1314.19 28.4882 1308.74 41.7121C1303.29 54.936 1295.3 66.9522 1285.22 77.0739C1275.15 87.1956 1263.18 95.2246 1250.02 100.703C1236.86 106.181 1222.75 109 1208.5 109C1194.25 109 1180.14 106.181 1166.98 100.703C1153.82 95.2246 1141.85 87.1956 1131.78 77.0739C1121.7 66.9522 1113.71 54.936 1108.26 41.7121C1102.81 28.4882 1100 14.3139 1100 0H1317Z",
    fill: "#F35F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManipalBg);
export default __webpack_public_path__ + "static/media/manipal-bg.f5aec769ce474a66e49e3add54e4e2bd.svg";
export { ForwardRef as ReactComponent };